<template>
  <!-- 案件详情-审核工作-糅合类型答题（事件信息+答题） -->
  <div class="examination-block">
    <ul class="content-block">
      <li v-for="(item, index) in issueList" :key="index" class="list-block">
        <h3 v-if="item.title" class="title on bold">{{ item.title }}</h3>

        <ul
          v-if="item && item.subproblems && item.subproblems.length"
          class="item-ul-content"
        >
          <li
            v-for="(zItem, zIndex) in item.subproblems"
            :key="zIndex"
            class="item-li-list"
          >
            <p v-if="zItem.questionName" class="item-title bold">
              {{ zIndex + 1 }}、{{ zItem.questionName }}
            </p>

            <!-- 已添加的记录 -->
            <ul v-if="zItem && zItem.multipleChoiceFlag" class="answer-record">
              <li
                v-for="(aItem, aIndex) in zItem.answers"
                :key="aIndex"
                class="item-input flex"
              >
                <p class="name-msg">{{ aItem.optionalName }}</p>

                <!-- paperCode大于10100的算新案件，额外显示日期控件 -->
                <div
                  v-if="caseInfo.paperCode <= 10100"
                  class="operate-block label-block flex"
                >
                  <p class="label-title">发生时间：</p>
                  <el-date-picker
                    v-model="aItem.happenTime"
                    align="right"
                    type="date"
                    placeholder="请选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </div>
                <div class="operate-block label-block flex">
                  <p class="label-title">备注：</p>
                  <el-input
                    v-model="aItem.remark"
                    placeholder="请输入备注内容"
                    class="input-block"
                  />
                </div>

                <!-- 多选类型-删除信息按钮 -->
                <el-button
                  type="danger"
                  icon="el-icon-minus"
                  size="small"
                  circle
                  class="sub-btn icon-btn"
                  :disabled="isCaseArchive"
                  @click="onSubAnswerItem(index, zIndex, aIndex)"
                />
              </li>
            </ul>

            <div class="item-input flex">
              <!-- questionType: 1、3  答题类型、答题+事件信息类型 -->
              <template
                v-if="
                  zItem &&
                    zItem.questionType != 2 &&
                    zItem.newOptions &&
                    zItem.newOptions.length
                "
              >
                <el-select
                  v-model="zItem.selectId"
                  placeholder="请选择"
                  class="operate-block select-block"
                >
                  <el-option
                    v-for="(oItem, oIndex) in zItem.newOptions"
                    :key="oIndex"
                    :label="
                      oItem.optionalName.length > 60
                        ? oItem.optionalName.substring(0, 60) + '...'
                        : oItem.optionalName
                    "
                    :value="oItem.optionalCode"
                  />
                </el-select>
                <!-- paperCode大于10100的算新案件，额外显示日期控件 -->
                <div
                  v-if="caseInfo.paperCode <= 10100"
                  class="operate-block label-block flex"
                >
                  <p class="label-title">发生时间：</p>
                  <el-date-picker
                    v-model="zItem.selectHappenTime"
                    align="right"
                    type="date"
                    placeholder="请选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </div>
                <div class="operate-block label-block flex">
                  <p class="label-title">备注：</p>
                  <el-input
                    v-model="zItem.selectRemark"
                    placeholder="请输入备注内容"
                    class="input-block"
                  />
                </div>
                <!-- 多选类型-增加信息按钮 -->
                <el-button
                  v-if="zItem.multipleChoiceFlag"
                  type="primary"
                  icon="el-icon-plus"
                  size="small"
                  circle
                  class="add-btn icon-btn"
                  :disabled="isCaseArchive"
                  @click="onAddAnswerItem(index, zIndex)"
                />
              </template>

              <!-- questionType: 2  事件信息的答题类型 -->
              <template v-else>
                <v-eventInfo
                  class="flex-block"
                  :event-value="zItem.eventValue"
                  @changeEventData="onChangeEventData"
                />
              </template>
            </div>

            <!-- questionType: 3  答题+事件信息类型-事件信息 -->
            <div
              v-if="
                zItem &&
                  zItem.questionType == 3 &&
                  zItem.newOptions &&
                  zItem.newOptions.length
              "
              class="item-input flex"
            >
              <v-eventInfo
                class="marginTop10"
                :event-value="zItem.eventValue"
                @changeEventData="onChangeEventData"
              />
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <!-- 保存信息 -->
    <div class="btn-block flex">
      <el-button
        type="primary"
        icon="el-icon-upload"
        class="btn-list"
        :loading="saveLoading"
        :disabled="(caseInfo && caseInfo.flowCode >= 101570) || !checkPermission('混合套题:保存', permList) || isCaseArchive"
        @click.stop="onSaveData"
      >
        保存信息
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EventInfo from '../eventInfo' // 事件信息

export default {
  name: 'Examination',

  components: {
    'v-eventInfo': EventInfo
  },

  data() {
    return {
      testItem: [], // 答题题目列表

      issueList: [], // 糅合答题列表
      // 糅合答题-顺序列表（模拟数据）
      listData: {},

      // 事件信息问题的标题
      eventIssueTitleObj: {
        cancerTime: '请填写会员首次确诊时间及发病时间', // 抗癌互助专属
        accidentTime: '请填写会员事故时间及死亡时间', // 意外互助专属
        lifeTrack: '生活轨迹情况',
        thirdPartyInsurance: '第三方保险/互助购买情况',
        hiddenDiseaseHistory: '健康风险评估',
        riskAppend: '受助会员本人、推荐人、家庭成员是否从事相关行业',
        isRiskMovement: '是否高风险运动',
        isRiskJob: '是否高风险职业',
        isRiskTask: '是否高风险作业',
        ywMutualStandard: '意外互助标准',
        accidentType: '事故类型',
        tnmInfo: '请填写TNM分期信息',
        cancerDiseaseInfo: '请填写诊断信息'
      },
      // 所有事件信息的key
      eventIssueSignArr: [
        'cancerDiseaseInfo', // 疾病名称、ICD10
        'cancerTime', // 抗癌-确诊时间、发病时间
        'accidentTime', // 意外-事故时间、死亡时间
        'tnmInfo', // TNM分期
        'lifeTrack', // 生活轨迹
        'thirdPartyInsurance', // 第三方保险/互助购买情况
        'hiddenDiseaseHistory', // 健康风险评估
        'riskAppend', // 是否从事相关的调查
        'isRiskMovement', // 是否高风险运动
        'isRiskJob', // 是否高风险职业
        'isRiskTask', // 是否高风险作业
        'ywMutualStandard', // 意外互助标准
        'accidentType' // 事故类型
      ],
      saveLoading: false, // 保存信息按钮的加载状态

      // 日期选择器-快捷选项
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },

  // 计算属性
  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500
    }
  },

  // 侦听器
  watch: {
    // 监听案件详情数据的变化
    caseInfo() {
      const {
        caseInfo: { caseCode },
        issueList
      } = this
      if (caseCode && !issueList.length) {
        this.fetchMixedPaperConfig()
      }
    }
  },

  mounted() {
    const {
      caseInfo: { caseCode }
    } = this
    if (caseCode) {
      this.fetchMixedPaperConfig()
    }
  },

  methods: {

    ...mapActions({
      setCaseInfo: 'caseDetail/setCaseInfo'
    }),

    /**
     * 获取案件混合题目配置
     */
    async fetchMixedPaperConfig() {
      const _this = this
      const {
        caseInfo: { caseCode }
      } = _this

      try {
        const { data: result } = await _this.axios.get(
          `/mixed-paper-config/query/${caseCode}`
        )

        _this.listData = result && result.data
        _this.getCaseRuleAnswerList()
      } catch (error) {
        console.log('获取案件混合题目配置-请求失败', error)
      }
    },

    /**
     * 查看当前案件告知/规则及答题结果
     */
    async getCaseRuleAnswerList() {
      const _this = this
      const {
        caseInfo: { caseCode }
      } = _this

      try {
        const { data: result } = await _this.axios.get(
          '/rule-answer/' + caseCode
        )

        if (result && result.status === '000000') {
          let data = result.data

          data =
            data &&
            data.map((item) => {
              return _this.onScreeningNewOptions(item)
            })

          _this.testItem = data
          _this.onFinishingIssueList()
        } else {
          _this.$alert('获取告知规则失败，请稍后再试')
        }
      } catch (error) {
        console.log('告别规则-请求失败', error)
      }
    },

    /**
     * 整理问题列表数据
     */
    onFinishingIssueList() {
      const _this = this
      const {
        eventIssueTitleObj,
        eventIssueSignArr,
        listData: { data },
        testItem
      } = _this
      const issueList = []

      data &&
        data.forEach((item, index) => {
          issueList.push({
            title: item.groupName,
            subproblems: []
          })

          item.groupConfig &&
            item.groupConfig.forEach((zItem, zIndex) => {
              let title = ''
              const newArr = zItem.split(',') // 拆分问题数组
              issueList[index].subproblems[zIndex] = {}

              newArr &&
                newArr.forEach((nItem) => {
                  // 遍历所有答题列表数据，并返回对应的内容（答题类型）
                  testItem &&
                    testItem.forEach((tItem) => {
                      if (tItem.questionCode == nItem) {
                        title = tItem.questionName
                        let questionType = 1
                        if (
                          issueList[index].subproblems[zIndex] &&
                          issueList[index].subproblems[zIndex].questionType
                        ) {
                          questionType =
                            issueList[index].subproblems[zIndex].questionType
                        }

                        issueList[index].subproblems[zIndex] = Object.assign(
                          issueList[index].subproblems[zIndex],
                          tItem
                        )
                        issueList[index].subproblems[zIndex].questionType = questionType

                        // 如果是单选类型的答题，则需要回显选中的数据
                        if (tItem && tItem.answers && !tItem.multipleChoiceFlag) {
                          issueList[index].subproblems[zIndex].selectId =
                            tItem.answers[0].optionalCode // 当前答题选中的答案Code
                          issueList[index].subproblems[zIndex].selectRemark =
                            tItem.answers[0].remark // 当前答题的备注信息
                        }
                      }
                    })

                  // 如果在答题列表中查找不到对应的答题，则当前题目为事件信息类型
                  if (eventIssueSignArr.indexOf(nItem) > -1) {
                    if (!title && eventIssueTitleObj[nItem]) {
                      title = eventIssueTitleObj[nItem]

                      issueList[index].subproblems[zIndex] = {
                        questionName: eventIssueTitleObj[nItem],
                        questionType: 2,
                        eventValue: nItem
                      }
                    } else {
                      // 第三种类型：普通答题+事件信息
                      if (issueList[index].subproblems[zIndex]) {
                        issueList[index].subproblems[zIndex].questionType = 3
                        issueList[index].subproblems[zIndex].eventValue = nItem
                      } else {
                        issueList[index].subproblems[zIndex] = {
                          questionType: 3,
                          eventValue: nItem
                        }
                      }
                    }
                  }
                })
            })
        })

      _this.issueList = JSON.parse(JSON.stringify(issueList))
    },

    /**
     * 筛选答题的选项
     * @param {any} item 每项的答题数据
     */
    onScreeningNewOptions(item) {
      const newOptions = []

      item &&
        item.options &&
        item.options.forEach((oItem) => {
          let sign = false
          // 如果当前答题是多选，则遍历答题选项列表和答题结果列表，并标记处相同的地方，在最后不在整合在一起
          if (item.multipleChoiceFlag) {
            item.answers &&
              item.answers.forEach((aItem) => {
                if (aItem.optionalCode === oItem.optionalCode) sign = true
              })
          }

          // 最后重新合并答题选项列表数据
          if (!sign) newOptions.push(oItem)
        })

      item.newOptions = newOptions
      return item
    },

    /**
     * 增加答题结果信息
     * @param {number} index  下标值（问题分类）
     * @param {number} zIndex 下标值（问题分类-子问题）
     */
    onAddAnswerItem(index, zIndex) {
      const _this = this
      const { issueList } = _this
      let itemData =
        issueList[index] &&
        issueList[index].subproblems &&
        issueList[index].subproblems[zIndex] // 对应的答题信息
      const { selectId, selectRemark, selectHappenTime } = itemData && itemData
      let { answers } = itemData && itemData

      // 判断是否有选中的答题结果ID
      if (!selectId) {
        _this.$alert('请先选择再点击添加记录！', '温馨提示')
      } else {
        const newAnswerItem = {
          happenTime: selectHappenTime || '',
          remark: selectRemark || '',
          optionalCode: selectId,
          optionalName: _this._getOptionalName(selectId)
        }
        if (!answers) answers = []
        answers.push(newAnswerItem)
        itemData.answers = answers
        // 清空当前输入框的状态
        itemData.selectId = ''
        itemData.selectRemark = ''
        itemData.selectHappenTime = ''
        itemData = _this.onScreeningNewOptions(itemData)

        _this.issueList = JSON.parse(JSON.stringify(issueList))
      }
    },

    /**
     * 删减答题结果信息
     * @param {number} index  下标值（问题分类）
     * @param {number} zIndex 下标值（问题分类-子问题）
     * @param {number} aIndex 下标值（问题分类-子问题-答题结果下标值）
     */
    onSubAnswerItem(index, zIndex, aIndex) {
      const { issueList } = this
      let itemData = issueList[index].subproblems[zIndex] // 对应的答题信息
      const { answers } = itemData && itemData
      answers.splice(aIndex, 1) // 截取当前删减的结果数据
      itemData = this.onScreeningNewOptions(itemData)

      this.issueList = JSON.parse(JSON.stringify(issueList))
    },

    /**
     * 修改事件信息中的指定数据
     * @param {string} key 键名
     * @param {string} value 数据
     */
    onChangeEventData(key, value) {
      const { caseInfo } = this
      const newCaseInfo = JSON.parse(JSON.stringify(caseInfo))
      newCaseInfo[key] = value
      this.setCaseInfo(newCaseInfo)
    },

    /**
     * 保存做题和事件信息
     */
    async onSaveData() {
      const _this = this
      const {
        caseInfo: { caseCode, paperCode },
        issueList
      } = _this
      const eventData = _this.getEventData()
      const questions = []

      issueList &&
        issueList.forEach((item) => {
          item &&
            item.subproblems &&
            item.subproblems.forEach((sItem) => {
              // 遍历答题类型的题目
              if (sItem && sItem.questionType && Number(sItem.questionType) !== 2) {
                // 判断当前答题类型的题目是否为单选题，如果是则默认答案数组为空
                let answers = []
                if (sItem.multipleChoiceFlag) answers = sItem.answers
                const options = JSON.parse(JSON.stringify(answers || []))

                // 判断当前答题中，是否有选中的答题结果
                if (sItem.selectId) {
                  options.push({
                    optionalCode: sItem.selectId,
                    happenTime: sItem.selectHappenTime || '', // 发生时间
                    remark: sItem.selectRemark || '', // 备注
                    optionalName: _this._getOptionalName(sItem.selectId)
                  })
                }

                if (sItem.questionCode && sItem.questionName) {
                  questions.push({
                    questionCode: sItem.questionCode,
                    questionName: sItem.questionName,
                    options
                  })
                }
              }
            })
        })

      const req = {
        detailParam: eventData,
        paperParam: {
          caseCode,
          paperCode,
          questions
        }
      }

      try {
        const { data: result } = await _this.axios.post(
          `/mixed-paper/save`,
          req
        )
        if (result && result.status === '000000') {
          _this.$alert('保存成功', '提示', {
            callback: () => {
              _this.$emit('getcaseInfo')
              _this.getCaseRuleAnswerList()
            }
          })
        } else {
          _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('保存做题和事件信息-请求失败', error)
      }
    },

    /**
     * 获取事件信息
     */
    getEventData() {
      const { caseInfo } = this
      if (caseInfo && caseInfo.caseCode) {
        const newObj = {
          flowCode: caseInfo.flowCode,
          caseCode: caseInfo.caseCode,
          detailVersion: caseInfo.detailVersion,

          // ================抗癌================
          degreeCode: caseInfo.degreeCode,
          firstDiagnosisTime: caseInfo.firstDiagnosisTime,
          symptomAppearanceTime: caseInfo.symptomAppearanceTime,
          survey: caseInfo.survey,
          chargeType: caseInfo.chargeType,
          kyMutualStandard: caseInfo.kyMutualStandard,

          // ================意外================
          accidentTime: caseInfo.accidentTime,
          memberDeathTime: caseInfo.memberDeathTime,
          accidentType: caseInfo.accidentType,
          accidentVehicle: caseInfo.accidentVehicle,
          driverLicenseValid: caseInfo.driverLicenseValid,
          ywMutualStandard: caseInfo.ywMutualStandard,

          isRiskMovement: caseInfo.isRiskMovement,
          riskMovement: caseInfo.riskMovement,
          riskMovementRemark: caseInfo.riskMovementRemark,
          isRiskJob: caseInfo.isRiskJob,
          riskJob: caseInfo.riskJob,
          isRiskTask: caseInfo.isRiskTask,
          riskTask: caseInfo.riskTask,
          riskTaskRemark: caseInfo.riskTaskRemark,

          // ================ICD================
          icdId: caseInfo.diseaseIcdInfo.id,
          tnmName: caseInfo.tnmName,
          mutualMoney: caseInfo.mutualMoney,

          // ================费用计算================
          cureTotal: caseInfo.cureTotal == '' ? 0 : caseInfo.cureTotal,
          thirdPartyExpense:
            caseInfo.thirdPartyExpense == '' ? 0 : caseInfo.thirdPartyExpense,
          socialSecurityExpense:
            caseInfo.socialSecurityExpense == '' ? 0 : caseInfo.socialSecurityExpense,
          // ================风险度信息================
          lifeTrack: caseInfo.lifeTrack,
          thirdPartyInsurance: caseInfo.thirdPartyInsurance,
          hiddenDiseaseHistory: caseInfo.hiddenDiseaseHistory,
          riskAppend: caseInfo.riskAppend
        }

        return newObj
      }
    },

    /**
     * 返回对应的答题结果描述
     * @param {string} optionalCode 答题结果Code
     */
    _getOptionalName(optionalCode) {
      const { testItem } = this
      let optionalName = '' // 答题结果描述

      testItem &&
        testItem.forEach((item) => {
          item &&
            item.options &&
            item.options.forEach((oItem) => {
              if (Number(oItem.optionalCode) === Number(optionalCode)) {
                optionalName = oItem.optionalName
              }
            })
        })

      return optionalName
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
